import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'signgaze-price-calculator-container',
  templateUrl: './price-calculator-container.component.html',
  styleUrls: ['./price-calculator-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceCalculatorContainerComponent implements OnChanges {
  readonly storeHoursPerDay: number = 14;
  @Input()
  screenPricePerSecond: number;

  impressionsPerHour = 30;
  adDuration = 10;
  impressionsPerDay: number;
  impressionsPerMonth: number;
  costPerImpression: number;
  timePerDay: number;
  totalPrice: number;

  ngOnChanges(): void {
    this.calculateScreenPricing();
  }

  public calculateScreenPricing(): void {
    this.costPerImpression = this.adDuration * this.screenPricePerSecond;
    this.impressionsPerDay = this.storeHoursPerDay * this.impressionsPerHour;
    this.timePerDay = (this.impressionsPerDay * this.adDuration) / 3600;
    this.impressionsPerMonth = 30 * this.impressionsPerDay;
    this.totalPrice = this.costPerImpression * this.impressionsPerMonth;
  }
}
